<template>
    <div class="open-article">
        <Breadcrumbs :theme="'light'" />
        <div class="container">
            <div class="row content-area">
                <section class="col-12 col-lg-8 col-xl-8 mt-4">
                    <Article
                        v-if="!!currentArticle"
                        class="mb-40px"
                        :article="currentArticle"
                        :commentsQuantity="commentsQuantity"
                        :likable="currentArticle.availableSections.isLikesActive"
                        :commentable="currentArticle.availableSections.isCommentsActive"
                        :sharable="currentArticle.availableSections.isShareActive"
                        :liked="likedPost"
                        @liked="onLikedPost"
                    />
                </section>
                <aside class="col-12 col-lg-4 col-xl-4 mt-4">
                    <section class="news-section">
                        <h2 class="news-section__title">{{ $t('labels.seeAlso') }}</h2>
                        <PreviewCard
                            :theme="'light'"
                            v-if="seeAlsoTopNews"
                            :data="seeAlsoTopNews"
                            :titleSymbolsCount="50"
                            :is-horizontal="!isDesktop"
                            :class="[mixinIsPhone(deviceWindowWidth) ? 'mb-20px' : 'mb-40px']"
                        />
                        <PreviewCardShort
                            :theme="'light'"
                            v-for="(preview, i) in seeAlsoNews"
                            :key="i"
                            :data="preview"
                            isSmall
                            :isExcerptPresent="!isDesktop"
                            :isCommentsCountShown="false"
                            excerpt-symbols-count="70"
                            :class="[mixinIsPhone(deviceWindowWidth) ? 'mb-10px' : 'mb-20px']"
                        />
                    </section>
                    <!-- <Banner
                        :bannerHeight="'380px'"
                        :bannerImage="bannerMockImage"
                        isBadgeAtRight
                    /> -->
                </aside>
            </div>
            <section class="content-area news-section news-section--dark-theme border-none bottom-news-section mt-20px">
                <h2 class="news-section__title">{{ $t('pages.esport.sections.moreArticles.title') }}</h2>

                <div class="row">
                    <div
                        v-for="(preview, i) in articles"
                        :key="i"
                        class="col-lg-6"
                    >
                        <PreviewCard
                            theme="light"
                            :data="preview"
                            :is-horizontal="!isSmAndDown"
                            class="mb-40px"
                        />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/Common/Breadcrumbs';
    import Article from '@/components/UIComponents/Article';
    import PreviewCard from '@/components/UIComponents/cards/PreviewCard';
    import PreviewCardShort from '@/components/UIComponents/cards/PreviewCardShort';
    import Banner from '@/components/Advertisement/Banner';
    import windowWidth from '../../../mixins/windowWidth';
    import translatePostResolver from '@/mixins/translatePostResolver'
    import metaTagsResolver from '@/helpers/metaTagsResolver'

    export default {
        name: 'ArticleItem',
        head() {
            const post = this.currentArticle
            const title = this.translatePost(post, 'title')
            const description = post.excerpt

            const metaTags = post['metaTags']
            const translateMetaTags = this.translatePost(post, 'metaTags')

            return metaTagsResolver({
                createdAt: post.createdAt,
                updatedAt: post.updatedAt,
                title,
                description,
                type: 'article',
                image: post.thumbnailImg.url
            }, metaTags, translateMetaTags)
        },
        //transition: 'fade',
        mixins: [windowWidth, translatePostResolver],
        components: {
            Breadcrumbs,
            Article,
            PreviewCard,
            PreviewCardShort,
            Banner,
        },
        data() {
            return {
                deviceWindowWidth: null,
                bannerMockImage: {
                    url: '/ad-test-img-1.png',
                    alt: '',
                },
                postActivity: null
            }
        },
        async fetch({ store, params, error }) {
            try {
                await store.dispatch('articles/fetchCurrentArticle', { slug: params.slug, params: {view:'client'} })
                const article = store.getters['articles/currentArticle']
                if(!article) {
                    error({ statusCode: 404, message: 'Not found' })
                }

                const postId = article.postId

                await store.dispatch('news-summary/fetchNewsSummary', {
                    limit: 9
                })

                await store.dispatch('articles-summary/fetchArticlesSummary', {
                    exclude: postId,
                    limit: 6
                })

                await store.dispatch('common/fetchPostCommentsQuantity', postId)

            } catch (e) {
                console.log(e)

                if(e.response) {
                    return error({ statusCode: e.response.status, message: e.response.data.message  })
                } else {
                    return e
                }
            }
        },
        async mounted() {
            this.deviceWindowWidth = window.innerWidth;

            await this.fetchPostActivity()
        },
        computed: {
            likedPost() {
                return this.postActivity
                    ? this.postActivity.likedPost
                    : false
            },
            news() {
                return this.$store.getters['news-summary/newsSummary']
            },
            seeAlsoTopNews() {
                if(!this.isDesktop) return null

                return this.news[0]
            },
            seeAlsoNews() {
                if(!this.isDesktop) {
                    return this.news
                }

                return this.news.slice(1)
            },
            articles() {
                return this.$store.getters['articles-summary/articlesSummary'];
            },
            currentArticle() {
                return this.$store.getters['articles/currentArticle']
            },
            commentsQuantity() {
                return this.$store.getters['common/postCommentsQuantity']
            }
        },
        methods: {
            async fetchPostActivity() {
                const auth = this.$store.getters['auth/user']
                const currentNews = this.currentArticle
                const postId = currentNews.postId
                const postType = currentNews.postType

                if (auth) {
                    const postActivityResponse = await this.$api.postActivity.getPostActivity(postType, postId, auth.userId)

                    this.postActivity = postActivityResponse.data.data
                }
            },
            async onLikedPost() {
                const auth = this.$store.getters['auth/user']

                if (!auth) return

                const post = this.currentArticle
                const activity = this.postActivity

                if(activity.likedPost) return

                try {
                    await this.$api.postActivity.updatePostActivity(post.postType, post.postId, auth.userId, {
                        likedPost: true
                    })

                    this.postActivity.likedPost = true
                    const likes = post.likes ? post.likes + 1 : 1

                    this.$store.commit('articles/setCurrentArticle', { ...post, likes })

                } catch (err) {
                    console.log(err)
                }
            }
        }
    }
</script>

<style lang="scss" >
    @import "~assets/css/_vars.scss";
    @import "~assets/css/_extension.scss";

    .open-article {
        background-color: #fff;
        color: $mainDarkFontColor;
        overflow: hidden;
        .breadcrumb a{
            color: $mainDarkFontColor;
        }
    }
    .news-section-card:last-child {
        margin-bottom: 30px;
    }
    .related-articles-section--tablet {
        padding-left: 15px;
        padding-right: 15px;
    }

    @media (max-width: $breakpoint-large-desktops) {
        .article-aside {
            .banner {
                width: 100% !important;
                margin-bottom: 30px;
            }
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .content-area {
            padding-left: 15px;
            padding-right: 15px;
        }
        .article-aside {
            border-top: 1px solid #cfcfcf;
            padding-top: 30px;
        }
        .content-with-aside-grid {
            padding-bottom: 0;
        }
    }

    @media (max-width: $breakpoint-phone) {
        .content-area {
            padding-left: 3px;
            padding-right: 3px;
        }
        .open-article {
            .news-section {
                padding-left: 3px;
                padding-right: 3px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            .news-section-card:last-child {
                margin-bottom: 20px;
            }
            .banner {
                margin-bottom: 0;
            }
        }
        .article-aside {
            border-top: none;
            padding-top: 0;
        }
    }
</style>
